import {func} from '@/func.js';

window.$func = func;


import axios from 'axios';
import router from '@/VueWorking/router.js';
// import sessionCheck from '@/VueWorking/sessionCheck.js';

// axios.defaults.baseURL = import.meta.env.VITE_APP_EMPLOYEE_URL;
axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

axios.interceptors.response.use(
    function (response){
        return response;
    }, 
    function (error) {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        console.log(error);
        if (error.response.status === 403) {
            console.log('Axios set 403');
            // document.cookie.split(";").forEach(function(c) { document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); });
            // localStorage.authenticated = 0;
            if (router.currentRoute.value.path !== '/errors/403') router.push('/errors/403');
        }
        if (error.response.status === 401) {
            console.log('Axios set 401');
            localStorage.authenticated = 0;
            router.push('/login');
        }
        if (error.response.status === 419) {
            // axios.get('/sanctum/csrf-cookie')
            console.log('Axios set 419');
            document.cookie.split(";").forEach(function(c) { document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); });
            localStorage.authenticated = 0;
            // window.location.reload();
            if (router.currentRoute.value.path !== '/login') router.push('/login');
        }
        // if (error.response.status === 422) {
        //     // axios.get('/sanctum/csrf-cookie')
        //     console.log('Axios set 422');
        //     localStorage.authenticated = 0;
        //     // console.log(error.response.statusText);
        //     router.push('/login');
        //     // sessionCheck().logoutSession();
        //     // router.push('/login');
        // }
        return Promise.reject(error);
    }
);


// global axios
window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';


// window.$func.getAlert = function (type, label, message){
//     let ev = new CustomEvent("modal-show", {
//         detail: {
//             open: true,
//             type: type,
//             label: label,
//             message: message,
//         },
//         bubbles: true,
//         cancelable: false,
//         composed: true,
//     });
//     document.dispatchEvent(ev);
// }

window.downloadHandler = function(name, filepath){
    var link = document.createElement("a");
    link.download = name;
    link.href = filepath + '?v=' + Math.random();
    link.click();
    link.remove();
}
